<div class="help-container">
    <div class="title">
        <h2>{{ 'help.title' | translate }}</h2>
    </div>
    <div class="questions">
        <p *ngFor="let question of questions" (click)="emitQuestion(question.index)">{{ question.text }}</p>
    </div>
</div>